/*******************************************************************************
LAZY LOAD CLOUDINARY IMAGES
We're using the Lozad libary with some adaptations.
*******************************************************************************/

import lozad from '../../../lib/_lozad/lozad.es';
import activateCloudinaryImages from './activate';

export default function initializeLazyLoading() {
    window.rwLazyLoader = lozad('.lozad', {
        // We don't want to do anything here since the Cloudinary library
        // takes care of loading the image.
        load  : () => {},
        loaded: (el) => {
            el.classList.add('cld-responsive');
            activateCloudinaryImages();
        },
        rootMargin: '150px 0px',
    });
    window.rwLazyLoader.observe();
}
